// string based off deploy.sh#L64
export const PRODUCTION = "prod";
export const STAGING = "REVIEW";
// export const DEVELOPMENT = "development";
export const isProd = process.env.NODE_ENV === PRODUCTION;
export const isStaging = process.env.NODE_ENV === STAGING;
export const isDev = process.env.NODE_ENV !== PRODUCTION;
